import Loader from "components/common/loader";
import { Button } from "components/shadcn/ui/button";
import { Card, CardContent } from "components/shadcn/ui/card";
import { Label } from "components/shadcn/ui/label";
import { ArrowRight, CreditCard, Send, TriangleAlert } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useOrganization } from "@clerk/clerk-react";
import { ORGANIZATION_ROLE } from "layout/sidebar/types";
import lang from "lang";

interface PaymentOverDueForMemberProps {}

const PaymentOverDueForMember: React.FC<PaymentOverDueForMemberProps> = () => {
  const { paymentOverDueMember: paymentOverDueMemberCopy } = lang;

  const { memberships, isLoaded } = useOrganization({ memberships: true });

  const [loading, setLoading] = useState(false);
  const [subscriptionEmail, setSubscriptionEmail] = useState("");

  useEffect(() => {
    if (!isLoaded || !memberships) return;

    setLoading(true);

    try {
      const adminMember = memberships?.data?.find(
        (member) => member.role === ORGANIZATION_ROLE.ADMIN
      );

      const email = adminMember?.publicUserData?.identifier;

      if (email) {
        setSubscriptionEmail(email);
      }
    } catch (error) {
      console.error("Error fetching organization admin email:", error);
    } finally {
      setLoading(false);
    }
  }, [isLoaded, memberships]);

  return (
    <div className="fullScreen">
      {loading && <Loader />}

      <div className="container">
        <div className="savedFiltersScreen">
          <div className="sfTitles flex flex-row items-center justify-between">
            <div className="flex flex-col">
              <div className="flex flex-row items-center gap-2">
                <CreditCard className="w-8 h-8 text-[var(--primary-700)]" />
                <span className="display-sm semibold text-gray-900">
                  {paymentOverDueMemberCopy.billng}
                </span>
              </div>

              <span className="text-md regular text-gray-600 pl-10">
                {paymentOverDueMemberCopy.manageBillingSubtext}{" "}
              </span>
            </div>
          </div>

          <Card className="w-full flex justify-center items-center border-none shadow-none h-[60vh]">
            <CardContent className="rounded-lg flex justify-center items-center flex-col w-[70%] bg-[--primary-50] p-4 gap-5">
              <div className="flex justify-center items-center flex-col gap-3">
                <TriangleAlert className="h-10 w-10 text-[--primary-700]" />
                <Label className="text-lg font-semibold">
                  {paymentOverDueMemberCopy.headingPaymentFailed}
                </Label>

                <div className="text-md font-normal text-gray-900 text-center">
                  {paymentOverDueMemberCopy.paymentFailedSubtext}
                </div>
              </div>

              <Card className="w-full h-full flex justify-center items-center border-none shadow-none">
                <CardContent className="rounded-lg justify-center items-center flex flex-col w-full h-full bg-white p-4 gap-4">
                  <div className="flex flex-row items-center gap-2 justify-center">
                    <Send className="h-8 w-8 text-[var(--primary-700)]" />
                    <Label className="text-lg font-semibold">
                      {paymentOverDueMemberCopy.headingActionRequired}
                    </Label>
                  </div>

                  <div className="text-md font-normal text-gray-900 text-center">
                    {paymentOverDueMemberCopy.subTextActionRequired}
                  </div>

                  <div className="flex justify-center">
                    <a
                      href={
                        subscriptionEmail
                          ? `mailto:${subscriptionEmail}`
                          : undefined
                      }
                    >
                      <Button variant="primary" disabled={!subscriptionEmail}>
                        {paymentOverDueMemberCopy.btnNotifyAccountOwner}{" "}
                        <ArrowRight />
                      </Button>
                    </a>
                  </div>
                </CardContent>
              </Card>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentOverDueForMember;
